import { render, staticRenderFns } from "./OP_Trending.vue?vue&type=template&id=d81cf800&scoped=true&"
import script from "./OP_Trending.vue?vue&type=script&lang=js&"
export * from "./OP_Trending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81cf800",
  null
  
)

export default component.exports